import { SignatureData } from "intake_shared/src/types";
import styles from "./SignaturePreview.module.scss";
import { cn } from "../../../../helpers";

interface SignaturePreviewProps {
    signature: SignatureData;
}

export default function SignaturePreview({ signature }: SignaturePreviewProps) {
    const disclaimer = `The information and material contained in this email message are intended only for the use of the addressee.  If you are not the intended recipient, then you are instructed not to disclose, copy or distribute this communication and you are instructed not to take any action with respect to it other than to immediately notify the sender and to delete the message from your system.

This communication contains protected health information and has been disclosed to you from records protected by Federal (HIPAA) and New York State privacy and confidentiality laws and regulations. This is strictly confidential material and is for the information of only the person or entity to whom it is addressed. No responsibility can be accepted if it is made available to any other person or entity.   Federal and New York State laws and regulations prohibit you from making any further disclosure of this information unless further disclosure is expressly permitted by the written authorization of the person to whom it pertains or is otherwise permitted by law.  Re-disclosure in violation of applicable laws and regulations may result in a fine or jail sentence or both. In certain instances, a general authorization for the release of health information is not sufficient authorization for further disclosure.



Despite our intentions even email sent to the correct address may be accessible to unauthorized persons because the “servers” through which email is routed are not securely protected.  Thus, the privacy and confidentiality of email communications cannot be assured. Please notify us in writing if you wish us not to send you any further emails; you may send us such notification by replying to this email.  If we do not hear from you, we will continue to communicate with you by email. 

            

Do not use email to communicate with us if a healthcare emergency arises.  We do not check emails frequently enough for it to be used in such emergencies.  Rather, contact us by telephone at the number above.`;

    return (
        <div className={styles.container}>
            <div className={styles.header}>
                <p className={styles.title}>Preview</p>
                <p className={styles.description}>
                    See how your signature will look
                </p>
            </div>
            {!signature.name || signature.name === "" ? (
                <div className={cn(styles.content, styles.placeholder)}>
                    Fill in the form to preview your signature
                </div>
            ) : (
                <div className={cn(styles.content, styles.signature)}>
                    <div className={styles.name}>
                        {signature.name}
                        {signature.pronouns && (
                            <span className={styles.pronouns}>
                                {" "}
                                ({signature.pronouns})
                            </span>
                        )}
                    </div>
                    {signature.department && (
                        <div className={styles.departmentTitle}>
                            {signature.department}
                        </div>
                    )}
                    {signature.company && (
                        <div className={styles.companyTitle}>
                            {signature.company}
                        </div>
                    )}

                    {(signature.phone || signature.directPhone) && (
                        <div>
                            {signature.phone && <div>{signature.phone}</div>}
                            {signature.directPhone && (
                                <div>
                                    <span className={styles.direct}>
                                        Text or direct call:{" "}
                                    </span>
                                    {signature.directPhone}
                                </div>
                            )}
                        </div>
                    )}

                    {signature.includeDisclaimer && (
                        <div className="signature-disclaimer">{disclaimer}</div>
                    )}
                </div>
            )}
        </div>
    );
}
